interface TrackingData {
  clarity: {
    sessionId: string | null;
    userId: string | null;
  };
  ga: {
    clientId: string | null;
    sessionId: string | null;
  };
  fb: {
    fbp: string | null;
    fbc: string | null;
  };
  shopify: {
    cartToken: string | null;
    customerId: string | null;
  };
  timestamp: number;
}

export const useCrossDomainTracking = () => {
  const trackingData = ref<TrackingData | null>(null);
  const config = useRuntimeConfig();

  const getTrackingData = () => {
    if (process.client) {
      try {
        // For testing, you can manually set some test data
        if (config.public.dev) {
          trackingData.value = {
            clarity: {
              sessionId: "test-session-id",
              userId: "test-user-id",
            },
            ga: {
              clientId: "test-ga-client-id",
              sessionId: "test-ga-session-id",
            },
            fb: {
              fbp: "test-fbp",
              fbc: "test-fbc",
            },
            shopify: {
              cartToken: "test-cart-token",
              customerId: "test-customer-id",
            },
            timestamp: Date.now(),
          };
          return trackingData.value;
        }

        const cookieValue = document.cookie
          .split("cross_domain_tracking=")
          .find((cookie) => cookie.startsWith("cross_domain_tracking="))
          ?.split(";")[0];

        if (cookieValue) {
          trackingData.value = JSON.parse(decodeURIComponent(cookieValue));
        }
      } catch (error) {
        console.error("Error parsing tracking data:", error);
      }
    }
    return trackingData.value;
  };

  // Watch for changes in the tracking data
  watch(trackingData, (newValue) => {
    if (newValue) {
      // You can emit events or update other parts of your application here
      // For example, update analytics or user state
    }
  });

  return {
    trackingData,
    getTrackingData,
  };
};
